import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import style from "./ProfileSavedCourses.module.css";

import { useParams } from "react-router-dom";

import ProfileEmptyTab from "../profileEmptyTab/ProfileEmptyTab";
import CourseCard from "@/features/courses/components/courseCard/CourseCard";
import TablePagination from "@/ui/tablePagination/TablePagination";

import { useGetUserSavedCourses } from "../../hooks/useGetUserSavedCourses";

import { useGetUserByUsername } from "@/features/auth/hooks/useGetUserByUsername";
import { useUser } from "@/features/auth/hooks/useUser";
import { useMediaQuery } from "@/hooks/useMediaQuery";

function profileSavedCourses() {
	const { t } = useTranslation();
	const { username } = useParams();
	const { courses, isPending } = useGetUserSavedCourses(username);
	const { user, isPending: userIsPending } = useGetUserByUsername(username);
	const { user: owner, isPending: ownerIsPending } = useUser();
	const isSmallScreen = useMediaQuery("(max-width: 1100px)");

	const [pagination, setPagination] = useState({
		pageIndex: 0,
		pageSize: 6,
	});

	useEffect(() => {
		if (isPending || !courses) return;

		const totalPages = Math.ceil(courses.length / pagination.pageSize);
		if (pagination.pageIndex >= totalPages && totalPages > 0) {
			setPagination((prev) => ({
				...prev,
				pageIndex: totalPages - 1,
			}));
		}
	}, [courses, isPending, pagination.pageSize, pagination.pageIndex]);

	if (isPending || userIsPending || ownerIsPending) return <></>;

	const startIndex = pagination.pageIndex * pagination.pageSize;
	const endIndex = startIndex + pagination.pageSize;
	const paginatedCourses = isSmallScreen
		? courses
		: courses.slice(startIndex, endIndex);

	const table = {
		getState: () => ({ pagination }),
		getRowCount: () => courses.length,
		getCanPreviousPage: () => pagination.pageIndex > 0,
		getCanNextPage: () => endIndex < courses.length,
		previousPage: () =>
			setPagination((prev) => ({
				...prev,
				pageIndex: prev.pageIndex - 1,
			})),
		nextPage: () =>
			setPagination((prev) => ({
				...prev,
				pageIndex: prev.pageIndex + 1,
			})),
	};

	if (!courses.length && owner?.username == username)
		return (
			<ProfileEmptyTab
				title={t("auth:profile.saved.ownEmpty.title")}
				description={t("auth:profile.saved.ownEmpty.description")}
				icon="fa-bookmark"
			/>
		);

	if (!courses.length && user?.username != owner?.username) {
		return (
			<ProfileEmptyTab
				title={t("auth:profile.saved.otherEmpty.title")}
				description={t("auth:profile.saved.otherEmpty.description")}
				icon="fa-bookmark"
			/>
		);
	}

	return (
		<div className={style.holder}>
			<div className={style.grid}>
				{paginatedCourses.map((course) => (
					<CourseCard
						showWatchList={true}
						course={course}
						key={course.name}
					/>
				))}
			</div>
			{!isSmallScreen && courses.length > pagination.pageSize && (
				<TablePagination table={table} />
			)}
		</div>
	);
}

export default profileSavedCourses;
